import React, { useState } from 'react';
import { X, Building2, Sun, Moon, Package, Grid, Shield, Users, Link, Database } from 'lucide-react';
import AdminEmpresas from './AdminEmpresas';
import AdminModulos from './AdminModulos';
import AdminSubmodulos from './AdminSubmodulos';
import AdminRoles from './AdminRoles';
import AdminRolSubmod from './AdminRolSubmod';
import AdminUsuarios from './AdminUsuarios';
import AdminDatabase from './AdminDatabase';
import { useTheme } from '../../App'

const AdminLayout = ({ onClose }) => {
  const [activeTab, setActiveTab] = useState('empresas');
  const { isDarkMode, toggleTheme } = useTheme();

  return (
    <div className={`fixed inset-0 ${isDarkMode ? 'bg-gray-900' : 'bg-white'} z-50 flex flex-col`}>
      <div className="h-full flex flex-col">
        
        {/* Header */}
        <div className={`px-6 py-4 border-b ${isDarkMode ? 'border-gray-700 bg-gray-800' : 'border-gray-200 bg-white'} flex items-center justify-between`}>
          <h2 className={`text-xl font-semibold ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>Panel de Configuración</h2>
          <div className="flex items-center space-x-2">
            {/* Botón de tema */}
            <button
              onClick={toggleTheme}
              className={`p-2 rounded-lg transition-colors ${isDarkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-100'}`}
              title={isDarkMode ? 'Modo Claro' : 'Modo Oscuro'}
            >
            {isDarkMode ? <Sun size={20} className="text-white" /> : <Moon size={20} className="text-gray-600" />}
            </button>
    
            {/* Botón cerrar */}
            <button
              onClick={onClose}
              className={`p-2 rounded-lg transition-colors ${isDarkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-100'}`}
            >
            <X size={20} className={isDarkMode ? 'text-white' : 'text-gray-600'} />
            </button>
          </div>
        </div>
                
        {/* Tabs */}
        <div className={`border-b ${isDarkMode ? 'border-gray-700' : 'border-gray-200'}`}>
          <div className="flex space-x-0 px-6">
            <button
              onClick={() => setActiveTab('empresas')}
              className={`flex items-center space-x-2 px-4 py-3 border-b-2 transition-colors ${
                activeTab === 'empresas'
                  ? `border-blue-600 text-blue-600 ${isDarkMode ? 'bg-blue-900/20' : 'bg-blue-50'}`
                  : `border-transparent ${isDarkMode ? 'text-gray-300 hover:text-white hover:bg-gray-700' : 'text-gray-600 hover:text-gray-800 hover:bg-gray-50'}`
              }`}
            >
              <Building2 size={18} />
              <span className="font-medium">Empresas</span>
            </button>
            <button
              onClick={() => setActiveTab('modulos')}
              className={`flex items-center space-x-2 px-4 py-3 border-b-2 transition-colors ${
                activeTab === 'modulos'
                  ? `border-blue-600 text-blue-600 ${isDarkMode ? 'bg-blue-900/20' : 'bg-blue-50'}`
                  : `border-transparent ${isDarkMode ? 'text-gray-300 hover:text-white hover:bg-gray-700' : 'text-gray-600 hover:text-gray-800 hover:bg-gray-50'}`
              }`}
            >
              <Package size={18} />
              <span className="font-medium">Módulos</span>
            </button>
            <button
              onClick={() => setActiveTab('submodulos')}
              className={`flex items-center space-x-2 px-4 py-3 border-b-2 transition-colors ${
                activeTab === 'submodulos'
                ? `border-blue-600 text-blue-600 ${isDarkMode ? 'bg-blue-900/20' : 'bg-blue-50'}`
                : `border-transparent ${isDarkMode ? 'text-gray-300 hover:text-white hover:bg-gray-700' : 'text-gray-600 hover:text-gray-800 hover:bg-gray-50'}`
              }`}
            >
              <Grid size={18} />
              <span className="font-medium">Submódulos</span>
            </button>            
            <button
              onClick={() => setActiveTab('roles')}
              className={`flex items-center space-x-2 px-4 py-3 border-b-2 transition-colors ${
              activeTab === 'roles'
              ? `border-blue-600 text-blue-600 ${isDarkMode ? 'bg-blue-900/20' : 'bg-blue-50'}`
              : `border-transparent ${isDarkMode ? 'text-gray-300 hover:text-white hover:bg-gray-700' : 'text-gray-600 hover:text-gray-800 hover:bg-gray-50'}`
              }`}
            >
              <Shield size={18} />
              <span className="font-medium">Roles</span>
            </button>
            <button
              onClick={() => setActiveTab('rolsubmod')}
              className={`flex items-center space-x-2 px-4 py-3 border-b-2 transition-colors ${
              activeTab === 'rolsubmod'
              ? `border-blue-600 text-blue-600 ${isDarkMode ? 'bg-blue-900/20' : 'bg-blue-50'}`
              : `border-transparent ${isDarkMode ? 'text-gray-300 hover:text-white hover:bg-gray-700' : 'text-gray-600 hover:text-gray-800 hover:bg-gray-50'}`
              }`}
            >
              <Link size={18} />
              <span className="font-medium">Rol-Submódulos</span>
            </button>
            <button
              onClick={() => setActiveTab('usuarios')}
              className={`flex items-center space-x-2 px-4 py-3 border-b-2 transition-colors ${
              activeTab === 'usuarios'
              ? `border-blue-600 text-blue-600 ${isDarkMode ? 'bg-blue-900/20' : 'bg-blue-50'}`
              : `border-transparent ${isDarkMode ? 'text-gray-300 hover:text-white hover:bg-gray-700' : 'text-gray-600 hover:text-gray-800 hover:bg-gray-50'}`
              }`}
            >
              <Users size={18} />
              <span className="font-medium">Usuarios</span>
            </button>
            <button
              onClick={() => setActiveTab('databases')}
              className={`flex items-center space-x-2 px-4 py-3 border-b-2 transition-colors ${
              activeTab === 'databases'
              ? `border-blue-600 text-blue-600 ${isDarkMode ? 'bg-blue-900/20' : 'bg-blue-50'}`
              : `border-transparent ${isDarkMode ? 'text-gray-300 hover:text-white hover:bg-gray-700' : 'text-gray-600 hover:text-gray-800 hover:bg-gray-50'}`
              }`}
            >
              <Database size={18} />
              <span className="font-medium">Databases</span>
            </button>
          </div>
        </div>
        {/* Content */}
        <div className="flex-1 flex flex-col overflow-hidden">
          {activeTab === 'empresas' && <AdminEmpresas />}
          {activeTab === 'modulos' && <AdminModulos />}
          {activeTab === 'submodulos' && <AdminSubmodulos />}
          {activeTab === 'roles' && <AdminRoles />}
          {activeTab === 'rolsubmod' && <AdminRolSubmod />}      
          {activeTab === 'usuarios' && <AdminUsuarios />}
          {activeTab === 'databases' && <AdminDatabase />}
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;